import Media from "./media";
import { Navigation, Pagination } from "swiper";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import LockedMedia from "./locked-media";

const MediaContainer = ({ message }) => {
    const purchased = () => {
        return [0, 2].includes(message.msg_type);
    };

    return <>
        <div className={'media-container'} style={{ minHeight: '50px' }}>
            {
                !purchased()
                    ? <LockedMedia message={message} />
                    : <Swiper pagination={true} modules={[Pagination, Navigation]} navigation={!isMobile} className="chat-gallery">
                        {
                            message.medias.map((media, index) => {
                                return <SwiperSlide key={`${media.media_id}-${index}`}>
                                    <Media key={`${media.media_id}-${index}`}
                                        media={media}
                                        message={message}
                                    />
                                </SwiperSlide>;
                            })
                        }
                    </Swiper>
            }
        </div>
    </>;
};


export default MediaContainer;
